module.exports = __webpack_public_path__ + "static/media/Betina G.0105c95e.jpg";